import Select from './select';
import { SelectsList, handleWindow, handleTrigger, handleOptions } from './handlers';

export default function setupSelects(className) {
  const selects = document.querySelectorAll(className);
  if (!selects || !selects.length) return;

  [...selects].forEach((select) => {
    const selectObj = new Select(className, select);

    SelectsList.push(selectObj);

    selectObj.reset();

    handleWindow();
    handleTrigger(selectObj);
    handleOptions(selectObj);
  });
}
